import { motion } from "framer-motion";
import { Globe, MapPin, Ship } from "lucide-react";

const REGIONS = [
  "North India", "West India", "South India", "East India", "Central India", "North-East",
];

export default function ExportPresence() {
  return (
    <section className="bg-[#f2ece4] py-20 md:py-28" data-testid="export-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <div>
            <div className="eyebrow text-[#d46a1d]">Distribution & Export</div>
            <h2 className="mt-3 font-serif text-4xl tracking-tight text-[#202124] md:text-5xl">
              A growing footprint across India — and beyond
            </h2>
            <p className="mt-4 text-lg text-[#55534e]">
              With partners in 20+ states and export-ready documentation, Saans Wellness is scaling authentic Ayurveda to new markets while keeping quality uncompromised.
            </p>

            <div className="mt-8 grid grid-cols-3 gap-4">
              {[["20+", "States served", MapPin], ["5+", "Export enquiries", Ship], ["1", "Vision — global", Globe]].map(([k, v, Icon], i) => (
                <div key={v} className="rounded-2xl border border-[#e7e0d6] bg-white p-5 card-shadow" data-testid={`export-stat-${i}`}>
                  <Icon size={18} className="text-[#1f5d3a]" />
                  <div className="mt-3 font-serif text-3xl text-[#202124]">{k}</div>
                  <div className="text-xs font-medium text-[#6b6a65]">{v}</div>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-wrap gap-2.5">
              {REGIONS.map((r) => (
                <span key={r} className="rounded-full border border-[#d8cfc1] bg-white px-4 py-2 text-sm font-medium text-[#4a4a48]">{r}</span>
              ))}
            </div>
          </div>

          <motion.div initial={{ opacity: 0, scale: 0.96 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }}
            transition={{ duration: 0.7 }} className="overflow-hidden rounded-[1.75rem] card-shadow-lg">
            <img src="https://images.unsplash.com/photo-1524661135-423995f22d0b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
              alt="Distribution network" loading="lazy" className="h-full w-full object-cover" />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
